import { render, staticRenderFns } from "./authenticationCompany.vue?vue&type=template&id=6c67935f&scoped=true"
import script from "./authenticationCompany.vue?vue&type=script&lang=js"
export * from "./authenticationCompany.vue?vue&type=script&lang=js"
import style0 from "./authenticationCompany.vue?vue&type=style&index=0&id=6c67935f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c67935f",
  null
  
)

export default component.exports